import type { AuthChangeEvent, Session } from '@supabase/supabase-js';
import { BaseApi } from './BaseApi';

/**
 * Thin, typed pass-throughs to the Supabase auth SDK used by AuthContext (session handling,
 * password sign-in, sign-up, sign-out). They return the SDK results unchanged so the context
 * keeps its own timeout and error handling.
 */
export class AuthSessionApi extends BaseApi {
  static setSession(tokens: { access_token: string; refresh_token: string }) {
    return this.getClient().auth.setSession(tokens);
  }

  static getSession() {
    return this.getClient().auth.getSession();
  }

  static onAuthStateChange(
    callback: (event: AuthChangeEvent, session: Session | null) => void | Promise<void>
  ) {
    return this.getClient().auth.onAuthStateChange(callback);
  }

  static signInWithPassword(credentials: { email: string; password: string }) {
    return this.getClient().auth.signInWithPassword(credentials);
  }

  static signOut() {
    return this.getClient().auth.signOut();
  }

  /** Create the auth user only (the profile row is written separately) */
  static signUp(email: string, password: string, name: string) {
    return this.getClient().auth.signUp({
      email,
      password,
      options: {
        data: { name }, // Only include name in metadata, not role
      },
    });
  }
}
